import React from "react";

const VehicleContext = React.createContext();

export default VehicleContext;